//@ts-nocheck
import {Column} from 'react-table'
import {ProjectInfoCell} from './ProjectInfoCell'
import {ProjectDescCell} from './ProjectDescCell'
// import {ProjectLastLoginCell} from './ProjectLastLoginCell'
// import {ProjectTwoStepsCell} from './ProjectTwoStepsCell'
import {ProjectActionsCell} from './ProjectActionsCell'
//import {ProjectSelectionCell} from './ProjectSelectionCell'
import {ProjectCustomHeader} from './ProjectCustomHeader'
//import {ProjectSelectionHeader} from './ProjectSelectionHeader'
import {Project} from '../../core/_models'

const projectColumns: ReadonlyArray<Column<Project>> = [
  {
    Header: (props) => (
      <ProjectCustomHeader
        tableProps={props}
        title='PROJECT.INPUT_CODE'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'code',
    Cell: ({...props}) => <ProjectInfoCell project={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <ProjectCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => <ProjectDescCell project={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <ProjectCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <ProjectActionsCell data={props.data[props.row.index]} />,
  },
]

export {projectColumns}
